var map = {
	"./MOUTH1.svg": 6111,
	"./MOUTH10.svg": 62112,
	"./MOUTH11.svg": 34046,
	"./MOUTH12.svg": 11681,
	"./MOUTH2.svg": 35282,
	"./MOUTH3.svg": 68327,
	"./MOUTH4.svg": 2055,
	"./MOUTH5.svg": 25644,
	"./MOUTH6.svg": 55511,
	"./MOUTH7.svg": 29267,
	"./MOUTH8.svg": 30680,
	"./MOUTH9.svg": 20299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84566;